import { render, staticRenderFns } from "./definition.vue?vue&type=template&id=134dc927&scoped=true"
import script from "./definition.vue?vue&type=script&lang=js"
export * from "./definition.vue?vue&type=script&lang=js"
import style0 from "./definition.vue?vue&type=style&index=0&id=134dc927&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134dc927",
  null
  
)

export default component.exports